import { render, staticRenderFns } from "./RightDrawer.vue?vue&type=template&id=cc048614&scoped=true"
import script from "./RightDrawer.vue?vue&type=script&lang=js"
export * from "./RightDrawer.vue?vue&type=script&lang=js"
import style0 from "./RightDrawer.vue?vue&type=style&index=0&id=cc048614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc048614",
  null
  
)

export default component.exports